import { COUNTRIES } from "./countries.js";
import { STATES } from "./usStates.js";
// VIB-1774 / VIB-1775: backend contract for the Apt / Suite / Unit field (`apt_po`) — max 64 chars.
export const APT_PO_MAX_LENGTH = 64;

// Join street and unit for display (space-separated, e.g. "20 Descanso Dr Unit 1331"). Unit is kept
// as its own value everywhere else and only concatenated here for read-only rendering (never for saving).
export function concatStreetAndUnit(street, apt_po){
    return [street, apt_po].filter(Boolean).join(' ');
}
export const basic_information_inputs_structure_data = [
    {
        input_id:'name',
        input_display_name:'Name',
        required:true,
        input_type:'input',
        disabled:true,
        unit_wrapper_classname:'Name-unit-wrapper',
    },
    {
        input_id:'birthdate',
        input_display_name:'DOB',
        required:true,
        input_type:'date-input-with-auto-format',
        unit_wrapper_classname:'DOB-unit-wrapper',
    },
    {
        input_id:'gender',
        input_display_name:'Gender',
        required:true,
        input_type:'selector',
        dropdown_options:[
            {
                label:"Male",
                value:"Male"
            },
            {
                label:"Female",
                value:"Female"
            }
        ],
        unit_wrapper_classname:'Gender-unit-wrapper',
    },
    {
        input_id:'phone',
        input_display_name:'Phone',
        input_type:'phone-input',
        unit_wrapper_classname:'Phone-unit-wrapper',
    },

];

export const shipping_address_inputs_structure_data = [
    {
        input_id:'name',
        input_display_name:'Recipient Name',
        input_display_note:'(To change the recipient name, please contact us at 866-364-0963)',
        required:true,
        input_type:'input',
        disabled:true,
        unit_wrapper_classname:'Name-unit-wrapper',
    },
    {
        input_id:'street',
        input_display_name:'Address Line',
        required: true,
        input_type:'customized_input',
        customized_component:'AddressAutoFilledInput',
        event:{
            emit_event:'selected-option-change',
            triggered_parent_event:'autofillAdressComponentSelectedOptionChange',
        },
        unit_wrapper_classname:'Address-Line-unit-wrapper',
    },
    {
        // VIB-1774: dedicated Apt / Suite / Unit field, stored separately from street as `apt_po`
        input_id:'apt_po',
        input_display_name:'Address Line 2',
        input_display_note:'(optional)',
        required:false,
        input_type:'input',
        text_length_limit:APT_PO_MAX_LENGTH,
        unit_wrapper_classname:'Apt-Suite-Unit-unit-wrapper',
    },
    {
        input_id:'zipcode',
        input_display_name:'Zip Code',
        required:true,
        input_type:'input',
        unit_wrapper_classname:'Zip-Code-unit-wrapper',
    },
    {
        input_id:'city',
        input_display_name:'City',
        required:true,
        input_type:'input',
        unit_wrapper_classname:'City-unit-wrapper',
    },
    {
        input_id:'state',
        input_display_name:'State',
        required:true,
        input_type:'selector',
        dropdown_options:getUSAStateDropwdownOptions(STATES),
        unit_wrapper_classname:'State-unit-wrapper',
    },
    {
        input_id:'country',
        input_display_note:"(If the patient's address is outside the U.S. or Canada, please contact your provider to have the correct address entered.)",
        input_display_name:'Country',
        required: true,
        input_type:'selector',
        dropdown_options:getCountryDropwdownOptions(COUNTRIES),
        unit_wrapper_classname:'Country-unit-wrapper',
    },
    
];
export function getCountryDropwdownOptions(countries){
    const output = countries.map((item)=>{
        return {
            label:`${item.name}(${item.code})`,
            value: item.code
        };
    })
    return output;
}
export function getUSAStateDropwdownOptions(states){
    const output = states.map((item)=>{
        return {
            label:`${item.name}(${item.abbreviation})`,
            value: item.abbreviation
        };
    })
    return output;
}

//find the corresponding country's country code based on param val
//if not find the matched one: return the original value
export function getCountryCode(val){
    //if val has two char -> assume this is the country code
    if(val.length==2){
        return val.toUpperCase();
    }else{
        for(const country of COUNTRIES){
            const upperCaseVal = val.toUpperCase();
            if(country.name.toUpperCase() == upperCaseVal || country.code == upperCaseVal){
                return country.code;
            }
        }
        return val;
    }
}

//find the corresponding country's country name based on param countryCode
//if not find matched one: return an empty string
export function getCountryNameViaCountryCode(countryCode){
    //if val has two char -> assume this is the country code
    for(const country of COUNTRIES){
        const upperCaseCountryCode = countryCode.toUpperCase();
        if(country.code.toUpperCase() == upperCaseCountryCode){
            return country.name;
        }
    }
    return '';
}

// export const units_wrappers_styles = {
//     patient_name:{
//         width:'100%'
//     },
//     street:{
//         width:'100%'
//     },
//     zipcode:{
//         width:'48%'
//     },
//     city:{
//         width:'48%'
//     },
//     state:{
//         width:'48%'
//     },
//     country:{
//         width:'48%'
//     }
// }